/**
 * Tasks is a book-scoped room. The book you open is the inventory you see.
 * Same door shape as PlotTrack. Writer-facing name is Tasks; leftover
 * /path URLs still resolve.
 */
export function pathRoomPath(storyId) {
  return storyId ? `/tasks/${storyId}` : '/tasks';
}

/** Discovery plot_ready offer opens Tasks, not Plot Workshop (#1089). */
/** Discovery's "Build my outline": Outline, where Generate builds it from the chat. */
export function plotReadyOfferPath(storyId) {
  return storyId ? `/plottrack/${storyId}` : '/plottrack';
}

/**
 * The book you are in — the one the left map is for — not most-recent
 * and not last-in-series. Used by the book-map Tasks door so the URL
 * on first paint is that book.
 */
export function pathRoomBookId({ pathname = '', currentStory, currentSession } = {}) {
  const notes = (pathname || '').match(/^\/projects\/[^/]+\/stories\/([^/]+)\/notes\/?$/);
  if (notes?.[1]) return notes[1];

  const onTasks = (pathname || '').match(/^\/(?:tasks|path)\/([^/]+)/);
  if (onTasks?.[1]) return onTasks[1];

  const onBring = (pathname || '').match(/^\/bring-into-book\/([^/]+)/);
  if (onBring?.[1]) return onBring[1];

  if ((pathname || '').startsWith('/chat/') && currentSession?.story_id) {
    return currentSession.story_id;
  }

  return currentStory?.id || currentSession?.story_id || null;
}

export function pathRoomPathForBook(ctx) {
  return pathRoomPath(pathRoomBookId(ctx));
}
